declare const brand: unique symbol;

type Brand<T, B extends string> = T & { readonly [brand]: B };

export type UserId = Brand<string, 'UserId'>;
export type Email = Brand<string, 'Email'>;
export type JWTToken = Brand<string, 'JWTToken'>;

export type AutoFormId = Brand<string, 'AutoFormId'>;
export type HomeFormId = Brand<string, 'HomeFormId'>;

export function createUserId(id: string): UserId {
  return id as UserId;
}

export function createEmail(email: string): Email {
  return email as Email;
}

export function createJWTToken(token: string): JWTToken {
  return token as JWTToken;
}

export function createAutoFormId(id: string): AutoFormId {
  return id as AutoFormId;
}

export function createHomeFormId(id: string): HomeFormId {
  return id as HomeFormId;
}

export function isUserId(value: unknown): value is UserId {
  return typeof value === 'string' && value.length > 0;
}

export function isEmail(value: unknown): value is Email {
  // Simplified email regex - basic validation only (full validation done server-side)
  return typeof value === 'string' && /^[^\s@]+@[^\s@]+$/.test(value);
}

export function isJWTToken(value: unknown): value is JWTToken {
  return typeof value === 'string' && value.split('.').length === 3;
}
